import { FunctionComponent, SVGProps } from 'react'

export const IconCog: FunctionComponent<SVGProps<SVGSVGElement>> = ({
  id,
  ...props
}) => {
  const filter0 = `${id}-filter0`
  const paint0 = `${id}-paint0`
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g filter={`url(#${filter0})`}>
        <path
          d="M12.0026 18.679C13.7707 18.679 15.4664 17.9767 16.7166 16.7264C17.9669 15.4762 18.6693 13.7805 18.6693 12.0124C18.6693 10.2443 17.9669 8.54857 16.7166 7.29832C15.4664 6.04808 13.7707 5.3457 12.0026 5.3457C10.2345 5.3457 8.5388 6.04808 7.28856 7.29832C6.03832 8.54857 5.33594 10.2443 5.33594 12.0124C5.33594 13.7805 6.03832 15.4762 7.28856 16.7264C8.5388 17.9767 10.2345 18.679 12.0026 18.679Z"
          fill={`url(#${paint0})`}
          shapeRendering="crispEdges"
        />
        <path
          d="M12.0026 18.679C13.7707 18.679 15.4664 17.9767 16.7166 16.7264C17.9669 15.4762 18.6693 13.7805 18.6693 12.0124C18.6693 10.2443 17.9669 8.54857 16.7166 7.29832C15.4664 6.04808 13.7707 5.3457 12.0026 5.3457C10.2345 5.3457 8.5388 6.04808 7.28856 7.29832C6.03832 8.54857 5.33594 10.2443 5.33594 12.0124C5.33594 13.7805 6.03832 15.4762 7.28856 16.7264C8.5388 17.9767 10.2345 18.679 12.0026 18.679Z"
          stroke="#C8F252"
          strokeLinecap="square"
          shapeRendering="crispEdges"
        />
      </g>
      <path
        d="M12.0026 13.679C12.4446 13.679 12.8686 13.5034 13.1811 13.1909C13.4937 12.8783 13.6693 12.4544 13.6693 12.0124C13.6693 11.5703 13.4937 11.1464 13.1811 10.8339C12.8686 10.5213 12.4446 10.3457 12.0026 10.3457C11.5606 10.3457 11.1367 10.5213 10.8241 10.8339C10.5115 11.1464 10.3359 11.5703 10.3359 12.0124C10.3359 12.4544 10.5115 12.8783 10.8241 13.1909C11.1367 13.5034 11.5606 13.679 12.0026 13.679Z"
        stroke="#C8F252"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 3.67773V5.3444"
        stroke="#C8F252"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 20.3444V18.6777"
        stroke="#C8F252"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.1693 19.2288L15.3359 17.7871"
        stroke="#C8F252"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.1693 10.5699L7.83594 4.79492"
        stroke="#C8F252"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.2151 16.179L17.7734 15.3457"
        stroke="#C8F252"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.78125 7.8457L6.22292 8.67904"
        stroke="#C8F252"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.6641 12.0117H20.3307"
        stroke="#C8F252"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.66406 12.0117H5.33073"
        stroke="#C8F252"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.2151 7.8457L17.7734 8.67904"
        stroke="#C8F252"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.78125 16.179L6.22292 15.3457"
        stroke="#C8F252"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.1693 4.79492L15.3359 6.23659"
        stroke="#C8F252"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.1693 13.4531L7.83594 19.2281"
        stroke="#C8F252"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <filter
          id={filter0}
          x="0.835938"
          y="0.845703"
          width="22.3359"
          height="22.334"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.784314 0 0 0 0 0.94902 0 0 0 0 0.321569 0 0 0 0.4 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_3707_30976"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_3707_30976"
            result="shape"
          />
        </filter>
        <linearGradient
          id={paint0}
          x1="12.0026"
          y1="5.3457"
          x2="12.0026"
          y2="18.679"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#C8F252" stopOpacity="0" />
          <stop offset="1" stopColor="#C8F252" stopOpacity="0.6" />
        </linearGradient>
      </defs>
    </svg>
  )
}
